import WeaDateGroup from "./index-old";
import WeaDateGroupMobx from "./index-mobx";
import middleware from "../../middleware";

class main extends React.Component {
  static defaultProps = {
    isMobx: false
  };
  constructor(props) {
    super(props);
  }
  render() {
    const { props } = this;
    if (props.isMobx) {
      return <WeaDateGroupMobx {...props} />;
    }
    return <WeaDateGroup {...props} />;
  }
}

const Com = middleware(main, "WeaDateGroup");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-date-group/index.js